/**
 * Decode JWT payload (no signature verification). Use only for UI hints;
 * authorization is enforced by the API and `useAuth().user` from `/me`.
 */
export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = JSON.parse(atob(padded));
    return json && typeof json === "object" ? json : null;
  } catch {
    return null;
  }
}

export function decodeRoleFromToken(token) {
  const p = decodeJwtPayload(token);
  const role = p?.role;
  return role === "admin" || role === "manager" || role === "designer" ? role : null;
}
